import { render, staticRenderFns } from "./ScreenSidebar.vue?vue&type=template&id=684a8727"
import script from "./ScreenSidebar.vue?vue&type=script&lang=js"
export * from "./ScreenSidebar.vue?vue&type=script&lang=js"
import style0 from "./ScreenSidebar.vue?vue&type=style&index=0&id=684a8727&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports